import {yupResolver} from '@hookform/resolvers/yup';
import Fuse from 'fuse.js';
import moment from 'moment';
import React, {ReactNode, useEffect, useState} from 'react';
import {FormProvider, SubmitHandler, useForm} from 'react-hook-form';
import {
  FlatList,
  SafeAreaView,
  Text,
  TextInput as TextInput1,
  View,
} from 'react-native';
import {useSelector} from 'react-redux';
import * as yup from 'yup';
import {ShowToast, retrieveSetting} from '../Common/common';
import BTButton from '../Components/BTButton';
import BTCheckbox from '../Components/BTCheckbox';
import BTComboBox from '../Components/BTComboBox';
import {BTDateTimePicker} from '../Components/BTDateTimePicker';
import {useGetPOAOutletsQuery} from '../redux/services/poaoutletApi';
import {useGetPOMGroupsQuery} from '../redux/services/pomgroupApi';
import {useGetPOMProductsQuery} from '../redux/services/pomproductApi';
import {useInsertPOMProductBlockMutation} from '../redux/services/pomproductblockApi';
import {RootState} from '../redux/store';
import styles from '../styles/Styles';

import T from '../Components/T';
import { tp } from '../utils/translateText';
interface item {
  pr_group?: number;
  pr_id: number;
  pr_name?: string;
  pr_isavail: boolean;
  value?: po_mproduct;
}

interface Quantities {
  [key: string]: {
    descr: string;
    avail: boolean;
  };
}

interface ColProps {
  children: ReactNode;
  style?: object;
}

interface RowProps {
  children: ReactNode;
}

const validationSchema = yup.object().shape({
  pa_fdate: yup
    .date()
    .required('From date is required')
    .test(
      'is-before-now',
      'From date must be before the current date and time',
      function (value) {
        return moment(value).isBefore(moment());
      },
    ),
  pa_tdate: yup
    .date()
    .required('To date is required')
    .test(
      'is-after-now',
      'To date must be after the current date and time',
      function (value) {
        return moment(value).isAfter(moment());
      },
    ),
});

const Col: React.FC<ColProps> = ({children, style}) => {
  return <View style={[styles.col, style]}>{children}</View>;
};

const Row: React.FC<RowProps> = ({children}) => {
  return <View style={styles.row}>{children}</View>;
};

const POSProductsBlock = ({navigation: {goBack}, route}: UniversalProps) => {
  const gdata: any = useSelector((state: RootState) => state.gdata);
  const {data: outletData} = useGetPOAOutletsQuery(gdata.company);
  const [search, setSearch] = useState('');
  const [group, setGroup] = useState(0);
  const [cart, setCart] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [quantities, setQuantities] = useState<Quantities>({});
  const [defOutlet, setDefOutlet] = useState(13);

  useEffect(() => {
    const retDefOutlet = async () => {
      setDefOutlet(Number(await retrieveSetting('defoutlet')));
    };

    retDefOutlet();
  }, []);

  const outlets = outletData?.map((value, i) => {
    return {
      label: value.ol_sname,
      id: value.ol_id,
      value: value,
    };
  });

  const {data, refetch} = useGetPOMProductsQuery({
    cid: gdata.company,
    olid: defOutlet ?? 0,
  });

  useEffect(() => {
    refetch();
  }, []);

  const {data: groupData} = useGetPOMGroupsQuery({
    cid: gdata.company,
    olid: defOutlet ?? 0,
  });

  const sortedData = [...(Array.isArray(groupData) ? groupData : [])]?.sort(
    (a, b) =>
      (Number(a.gr_sort) <= 0 ? 9999 : a.gr_sort) -
      (Number(b.gr_sort) <= 0 ? 9999 : b.gr_sort),
  );

  const groups: any = sortedData?.map((value, _key) => {
    return {
      label: value.gr_name,
      id: value.gr_id,
      value: value,
    };
  });

  const products1: any = data?.map((value, _key) => {
    return {
      pr_group: value.pr_group,
      pr_id: value.pr_id,
      pr_name: value.pr_name,
      pr_grname: value.pr_grname,
      pr_isavail: value.pr_avail,
      value: value,
    };
  });

  const renderSeparator = () => {
    return (
      <View
        style={{
          height: 1,
          width: '86%',
          backgroundColor: '#CED0CE',
          marginLeft: '14%',
        }}
      />
    );
  };

  const handleCart = (item: item, avail: boolean) => {
    setQuantities({
      ...quantities,
      [item.pr_id]: {
        descr: item.pr_name,
        avail: avail,
      },
    });
  };

  const handleCartClick = () => {
    setCart(!cart);

    setGroup(0);
    setSearch('');
  };

  const [products, setProducts] = useState(products1);

  useEffect(() => {
    const prods = products1?.filter((v: any) => {
      return Number(v.pr_group) == Number(group) || Number(group) == 0;
    });

    if (search.length >= 3 && !cart) {
      const options = {
        includeScore: true,
        useExtendedSearch: true,
        keys: ['pr_name'],
      };

      const fuse = new Fuse(prods, options);
      const b = fuse.search(search);
      const c = b.map(v => {
        return v.item;
      });

      setProducts(c);
    } else if (search == '') {
      setProducts(
        prods?.filter((v: any) => {
          return (quantities?.hasOwnProperty(v.pr_id) && cart) || !cart;
        }),
      );
    }
  }, [search, data, cart, group]);

  let initialValues: any = {
    pa_fdate: moment().startOf('day').toDate(),
    pa_tdate: moment().endOf('day').toDate(),
    pa_remarks: '',
    pa_details: [],
    avail: [],
  };

  const {...methods} = useForm<any>({
    defaultValues: initialValues,
    resolver: yupResolver(validationSchema),
  });

  const [insertPOMProductBlock] = useInsertPOMProductBlockMutation();

  const onSubmit: SubmitHandler<any> = async values => {
    if (isSaving) {
      return;
    }

    try {
      let itms: po_mproductblock[] = [];
      let i = 1;
      for (const [id, product] of Object.entries(quantities)) {
        const {avail} = product;

        itms.push({
          pa_id: 0,
          pa_date: moment().toDate(),
          pa_prod: Number(id),
          pa_fdate: new Date(values.pa_fdate),
          pa_tdate: new Date(values.pa_tdate),
          pa_remarks: values.pa_remarks,
          pa_flag: avail ? '1' : '0',
          pa_uid: gdata.user,
          pa_cdt: moment().toDate(),
          pa_muid: gdata.user,
          pa_mdt: moment().toDate(),
        });
      }

      if (itms.length === 0) {
        ShowToast('Select Menu Items', 'error');

        return;
      }
      setIsSaving(true);

      await insertPOMProductBlock(itms).unwrap();

      methods.reset();

      ShowToast('Data Saved Sucessfully');

      setIsSaving(false);
      goBack();
    } catch (e: any) {
      ShowToast(e?.data?.message || e?.message || 'Failed to save data', 'error');
      setIsSaving(false);
    }
  };

  const updateItemField = (field: string, avail: boolean, itemId: string) => {
    setQuantities((prevQuantities: any) => {
      const currentItem = prevQuantities[itemId] || {
        avail: true,
      };

      const updatedItem = {
        ...currentItem,
        [field]: avail,
      };

      return {
        ...prevQuantities,
        [itemId]: updatedItem,
      };
    });
  };

  useEffect(() => {
    products?.map((item: any) => {
      if (item.pr_isavail == 0) {
        updateItemField('avail', false, item.pr_id);
      }
    });
  }, [products]);

  useEffect(() => {
    // Iterate over the object entries of quantities
    Object.entries(quantities || {}).forEach(([itemId, item]) => {
      // Adjust the condition based on your actual logic
      // For example, you might want to check item.avail or similar
      if (!item.avail) {
        // Assuming methods.setValue is a way to set some state or form field
        // Update the state/form based on the item's ID and your condition
        methods.setValue(`avail.${itemId}`, item.avail);
      }
    });
  }, [quantities]);

  const renderItem = (item: any, i: number) => {
    return item ? (
      <View style={styles.conLstItem} key={item.pr_id}>
        <View style={styles.conLstData}>
          {group == 0 ? (
            <Row>
              <Col>
                <Text style={styles.descr}>{item?.pr_grname}</Text>
              </Col>
            </Row>
          ) : null}
          <Row>
            <Col style={{maxWidth: 70}}>
              <BTCheckbox
                label=""
                name={`avail.${item.pr_id}`}
                defaultValue={true}
                onValChange={(v: boolean) => {
                  handleCart(item, v);
                  updateItemField('avail', v, item.pr_id);
                }}
              />
            </Col>
            <Col style={{flex: 1, minWidth: 100}}>
              <Text style={styles.heading}>{item?.pr_name}</Text>
            </Col>
          </Row>
        </View>
      </View>
    ) : (
      <View />
    );
  };

  const [showHead, setShowHead] = useState(true);

  return (
    <View style={styles.app}>
      {/* Modern Header */}
      <View style={styles.modernHeaderContainer}>
        <Text style={styles.modernHeaderTitle}><T>Unavailable Items</T></Text>
      </View>

      <FormProvider {...methods}>
        <SafeAreaView>
          {showHead ? (
            <>
              <Row>
                <Col>
                  <BTDateTimePicker name="pa_fdate" label="From" mode="time" />
                </Col>
                <Col>
                  <BTDateTimePicker name="pa_tdate" label="To" mode="time" />
                </Col>
              </Row>
              <Row>
                <Col>
                  <BTButton
                    title="2Hrs"
                    color="#146C94"
                    onPress={() => {
                      methods.setValue(
                        'pa_tdate',
                        moment().add(2, 'hours').toDate(),
                      );
                    }}
                    onLongPress={() => {}}
                    disabled={isSaving}
                  />
                </Col>
                <Col>
                  <BTButton
                    title="4Hrs"
                    color="#146C94"
                    onPress={() => {
                      methods.setValue(
                        'pa_tdate',
                        moment().add(4, 'hours').toDate(),
                      );
                    }}
                    onLongPress={() => {}}
                    disabled={isSaving}
                  />
                </Col>
                <Col>
                  <BTButton
                    title="6Hrs"
                    color="#146C94"
                    onPress={() => {
                      methods.setValue(
                        'pa_tdate',
                        moment().add(6, 'hours').toDate(),
                      );
                    }}
                    onLongPress={() => {}}
                    disabled={isSaving}
                  />
                </Col>
                <Col>
                  <BTButton
                    title="8Hrs"
                    color="#146C94"
                    onPress={() => {
                      methods.setValue(
                        'pa_tdate',
                        moment().add(8, 'hours').toDate(),
                      );
                    }}
                    onLongPress={() => {}}
                    disabled={isSaving}
                  />
                </Col>
                <Col>
                  <BTButton
                    title="Disable"
                    color="#146C94"
                    onPress={() => {
                      methods.setValue(
                        'pa_tdate',
                        moment().add(10, 'years').toDate(),
                      );
                    }}
                    onLongPress={() => {}}
                    disabled={isSaving}
                  />
                </Col>
              </Row>
            </>
          ) : null}
          <Row>
            <Col>
              <View style={styles.button}>
                <BTButton
                  title="Save"
                  color="#146C94"
                  onPress={methods.handleSubmit(onSubmit)}
                  onLongPress={() => {}}
                  disabled={isSaving}
                />
              </View>
            </Col>
            <Col>
              <View style={styles.button}>
                <BTButton
                  title="Reset"
                  color="#146C94"
                  onPress={() => {
                    methods.reset();
                    setQuantities({});
                  }}
                  onLongPress={() => {}}
                  disabled={isSaving}
                />
              </View>
            </Col>
            <Col>
              <View style={styles.button}>
                <BTButton
                  title="View"
                  color={cart ? '#19A7CE' : '#146C94'}
                  onPress={() => handleCartClick()}
                  onLongPress={() => {}}
                  disabled={isSaving}
                />
              </View>
            </Col>
            <Col>
              <View style={styles.button}>
                <BTButton
                  title={`Time`}
                  color={showHead ? '#19A7CE' : '#146C94'}
                  onPress={() => setShowHead(prev => !prev)}
                  onLongPress={() => {}}
                  disabled={isSaving}
                />
              </View>
            </Col>
          </Row>
          <Row>
            <Col>
              <BTComboBox
                name="group"
                label="Group"
                data={groups}
                placeholder={tp("Table No")}
                onValChange={(v: any) => setGroup(v)}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <SafeAreaView>
                <TextInput1
                  style={styles.text}
                  onChangeText={setSearch}
                  value={search}
                  placeholder={tp("Search")}
                />
              </SafeAreaView>
            </Col>
          </Row>
          <SafeAreaView>
            <FlatList
              ItemSeparatorComponent={renderSeparator}
              data={products}
              renderItem={({item, index}) => renderItem(item, index)}
              onEndReachedThreshold={0.1}
              contentContainerStyle={{paddingBottom: 350}}
              keyboardShouldPersistTaps="handled"
            />
          </SafeAreaView>
        </SafeAreaView>
      </FormProvider>
    </View>
  );
};

export default POSProductsBlock;

